import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { api, extractError } from '@/lib/api.js';
import { FieldTip } from '@/components/FieldTip.js';

type Props = { diagnosticoId: string };

export function InviteByEmail({ diagnosticoId }: Props) {
  const [email, setEmail] = useState('');
  const [msg, setMsg] = useState<string | null>(null);

  const invite = useMutation({
    mutationFn: async () =>
      (await api.post<{ ok: boolean; link?: string; message?: string }>(
        `/diagnosticos/${diagnosticoId}/convidar`,
        { email: email.trim() },
      )).data,
    onSuccess: (data) => {
      if (data.ok) {
        setMsg('Convite enviado por e-mail.');
      } else {
        setMsg(data.message ?? `E-mail não enviado. Link: ${data.link ?? ''}`);
      }
      setEmail('');
    },
    onError: (e) => setMsg(extractError(e).message),
  });

  return (
    <div className="mb-4 max-w-md border border-ha-border bg-ha-card2 p-4">
      <h3 className="mb-2 text-xs font-bold uppercase text-ha-muted">Convidar sócio por e-mail</h3>
      <div className="flex flex-col gap-2 sm:flex-row sm:items-end">
        <div className="flex-1">
          <FieldTip label="E-mail do sócio" hint="Enviaremos o link do diagnóstico por e-mail (Resend).">
            <input
              type="email"
              className="w-full border border-ha-border2 bg-ha-card px-3 py-2 text-sm"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="socio@empresa.com"
            />
          </FieldTip>
        </div>
        <button
          type="button"
          disabled={!email.trim() || invite.isPending}
          className="px-4 py-2 text-xs font-bold text-black disabled:opacity-40"
          style={{ background: '#ffc800' }}
          onClick={() => invite.mutate()}
        >
          {invite.isPending ? 'Enviando…' : 'Enviar convite'}
        </button>
      </div>
      {msg && <p className="mt-2 text-xs text-ha-subtle">{msg}</p>}
    </div>
  );
}
